import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { parseNumberToHours } from './helpers';
dayjs.extend(utc);
dayjs.extend(timezone);

export type PricingFrequency = {
    value: string;
    label: string;
    priceSuffix: string;
};

export type PriceType = {
    month: string;
    year: string;
};

export type PricingTier = {
    name: string;
    id: string;
    price: PriceType;
    description: string;
    features: string[];
    mostPopular: boolean;
    frequency?: string;
};

export const frequencies: PricingFrequency[] = [
    { value: 'month', label: 'Monthly', priceSuffix: '/month' },
    { value: 'year', label: 'Annually', priceSuffix: '/year' },
];

export const tiers: PricingTier[] = [
    {
        name: 'Free',
        id: 'free',
        price: { month: '£0', year: '£0' },
        description: 'The essentials to provide your best work for clients.',
        features: ['5 products', 'Up to 1,000 subscribers', 'Basic analytics', '48-hour support response time'],
        mostPopular: false,
    },
    {
        name: 'Startup',
        id: 'startup',
        price: { month: '£15', year: '£144' },
        description: 'The essentials to provide your best work for clients.',
        features: ['5 products', 'Up to 1,000 subscribers', 'Basic analytics', '48-hour support response time'],
        mostPopular: false,
    },
    {
        name: 'Pro',
        id: 'pro',
        price: { month: '£30', year: '£288' },
        description: 'A plan that scales with your rapidly growing business.',
        features: [
            '25 products',
            'Up to 10,000 subscribers',
            'Advanced analytics',
            '24-hour support response time',
            'Marketing automations',
        ],
        mostPopular: true,
    },
    {
        name: 'Enterprise',
        id: 'enterprise',
        price: { month: '£60', year: '£576' },
        description: 'Dedicated support and infrastructure for your company.',
        features: [
            'Unlimited products',
            'Unlimited subscribers',
            'Advanced analytics',
            '1-hour, dedicated support response time',
            'Marketing automations',
            'Custom reporting tools',
        ],
        mostPopular: false,
    },
];

export const eventTypesRadioButtons = [
    { id: 'Live', title: 'Live' },
    { id: 'Simu', title: 'Simu-live' },
    { id: 'VOD', title: 'On-demand' },
];

export const stripePublicKey: string =
    'pk_test_51NbgaSCEhwmGK7PgINTNhvxG0s1U72qO4xAJ86WQbmm3Ub3obAH1SObn2bx4dIzVngWuFdob7WUYLHuzWfo9s2kX0015idmGnV';
export const priceId: string = 'price_1NbgxwCEhwmGK7PgHWCZRgUq';
export const checkMarkGreenRegister: string =
    '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';
export const checkMarkBlackRegister: string =
    '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';

export const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const allHourMinute: string[] = (() => {
    let arr: string[] = [];
    const start = new Date();
    start.setHours(0, 0, 0); //8 AM
    const end = new Date();
    end.setHours(23, 59, 0); //5 PM

    while (start <= end) {
        arr.push(start.toLocaleString('en-UK', { hour: '2-digit', minute: '2-digit' }));
        start.setMinutes(start.getMinutes() + 30);
    }
    return arr;
})();

export const allTimezones: { key: string; value: string }[] = Object.entries({
    'Pacific/Midway': 'Midway Island, Samoa',
    'Pacific/Honolulu': 'Hawaii',
    'America/Juneau': 'Alaska',
    'America/Boise': 'Mountain Time',
    'America/Dawson': 'Dawson, Yukon',
    'America/Chihuahua': 'Chihuahua, La Paz, Mazatlan',
    'America/Phoenix': 'Arizona',
    'America/Chicago': 'Central Time',
    'America/Regina': 'Saskatchewan',
    'America/Mexico_City': 'Guadalajara, Mexico City, Monterrey',
    'America/Belize': 'Central America',
    'America/Detroit': 'Eastern Time',
    'America/Bogota': 'Bogota, Lima, Quito',
    'America/Caracas': 'Caracas, La Paz',
    'America/Santiago': 'Santiago',
    'America/St_Johns': 'Newfoundland and Labrador',
    'America/Sao_Paulo': 'Brasilia',
    'America/Tijuana': 'Tijuana',
    'America/Montevideo': 'Montevideo',
    'America/Argentina/Buenos_Aires': 'Buenos Aires, Georgetown',
    'America/Godthab': 'Greenland',
    'America/Los_Angeles': 'Pacific Time',
    'Atlantic/Azores': 'Azores',
    'Atlantic/Cape_Verde': 'Cape Verde Islands',
    GMT: 'UTC',
    'Europe/London': 'Edinburgh, London',
    'Europe/Dublin': 'Dublin',
    'Europe/Lisbon': 'Lisbon',
    'Africa/Casablanca': 'Casablanca, Monrovia',
    'Atlantic/Canary': 'Canary Islands',
    'Europe/Belgrade': 'Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    'Europe/Zagreb': 'Zagreb, Sarajevo, Skopje, Warsaw',
    'Europe/Brussels': 'Brussels, Copenhagen, Madrid, Paris',
    'Europe/Amsterdam': 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    'Africa/Algiers': 'West Central Africa',
    'Europe/Bucharest': 'Bucharest',
    'Africa/Cairo': 'Cairo',
    'Europe/Helsinki': 'Helsinki, Kyiv (Kiev), Riga, Sofia, Tallinn, Vilnius',
    'Europe/Athens': 'Athens',
    'Asia/Jerusalem': 'Jerusalem',
    'Africa/Harare': 'Harare, Pretoria',
    'Europe/Moscow': 'Istanbul, Minsk, Moscow, St. Petersburg, Volgograd',
    'Asia/Kuwait': 'Kuwait, Riyadh',
    'Africa/Nairobi': 'Nairobi',
    'Asia/Baghdad': 'Baghdad',
    'Asia/Tehran': 'Tehran',
    'Asia/Dubai': 'Abu Dhabi, Muscat',
    'Asia/Baku': 'Baku, Tbilisi, Yerevan',
    'Asia/Kabul': 'Kabul',
    'Asia/Yekaterinburg': 'Ekaterinburg',
    'Asia/Karachi': 'Islamabad, Karachi, Tashkent',
    'Asia/Kolkata': 'Chennai, Kolkata, Mumbai, New Delhi',
    'Asia/Kathmandu': 'Kathmandu',
    'Asia/Dhaka': 'Astana, Dhaka',
    'Asia/Colombo': 'Sri Jayawardenepura',
    'Asia/Almaty': 'Almaty, Novosibirsk',
    'Asia/Rangoon': 'Yangon Rangoon',
    'Asia/Bangkok': 'Bangkok, Hanoi, Jakarta',
    'Asia/Krasnoyarsk': 'Krasnoyarsk',
    'Asia/Shanghai': 'Beijing, Chongqing, Hong Kong SAR, Urumqi',
    'Asia/Kuala_Lumpur': 'Kuala Lumpur, Singapore',
    'Asia/Taipei': 'Taipei',
    'Australia/Perth': 'Perth',
    'Asia/Irkutsk': 'Irkutsk, Ulaanbaatar',
    'Asia/Seoul': 'Seoul',
    'Asia/Tokyo': 'Osaka, Sapporo, Tokyo',
    'Asia/Yakutsk': 'Yakutsk',
    'Australia/Darwin': 'Darwin',
    'Australia/Adelaide': 'Adelaide',
    'Australia/Sydney': 'Canberra, Melbourne, Sydney',
    'Australia/Brisbane': 'Brisbane',
    'Australia/Hobart': 'Hobart',
    'Asia/Vladivostok': 'Vladivostok',
    'Pacific/Guam': 'Guam, Port Moresby',
    'Asia/Magadan': 'Magadan, Solomon Islands, New Caledonia',
    'Asia/Kamchatka': 'Kamchatka, Marshall Islands',
    'Pacific/Fiji': 'Fiji Islands',
    'Pacific/Auckland': 'Auckland, Wellington',
    'Pacific/Tongatapu': "Nuku'alofa",
})
    .sort((a, b) => {
        return dayjs().tz(a[0]).utcOffset() - dayjs().tz(b[0]).utcOffset();
    })
    .map((zone) => {
        let tzOffsetString: string = '';
        const tzLongNameArr = new Date()
            .toLocaleString('en-US', { timeZone: zone[0], timeZoneName: 'long' })
            .split(' ');

        tzLongNameArr.splice(0, 3);
        const tzShortName = tzLongNameArr.map((str) => str.charAt(0)).join('');
        const tzOffset: number = dayjs().tz(zone[0]).utcOffset() / 60;
        tzOffsetString = parseNumberToHours(tzOffset);

        return { key: zone[0], value: `(UTC${tzOffsetString}) ${zone[1]} (${tzShortName})` };
    });
